import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const BackNavigator = () => {
  let navigate = useNavigate();
  return (
    <ChevronLeftIcon
      data-testid="backnavigator"
      style={{ width: "1.5em", height: "1.5em", cursor: "pointer" }}
      onClick={() => navigate("/summary")}
    ></ChevronLeftIcon>
  );
};

export default BackNavigator;
